import React, { useState } from "react";

// Using a valid icon for the placeholder
import {
  CurrencyDollarIcon,
  ShoppingBagIcon,
  GiftIcon,
} from "@heroicons/react/24/solid";

// Icon mapping using a valid icon and consistent styling
const getIconForItem = (itemName) => {
  const iconClasses = "w-6 h-6 text-indigo-600";
  switch (true) {
    case /Milk/.test(itemName):
      return (
        <img src="/icons/milk-can.png" alt="Milk Can" className="w-6 h-6" />
      );
    case /Money/.test(itemName):
      return <CurrencyDollarIcon className={iconClasses} />;
    case /Ghee/.test(itemName):
      return <img src="/icons/ghee.png" alt="Milk Can" className="w-6 h-6" />;
    case /Feed/.test(itemName):
      return <img src="/icons/feed.png" alt="Milk Can" className="w-6 h-6" />;
    default:
      return <CurrencyDollarIcon className={iconClasses} />;
  }
};

// Color logic now returns a class based on the transaction type
const getColorForTransaction = (itemName) => {
  if (/Money Given|Feed|Ghee/.test(itemName)) {
    return "text-red-500";
  }
  if (/Money Received|Milk/.test(itemName)) {
    return "text-green-600";
  }
  return "text-gray-500";
};

const TransactionItem = ({ data, onDelete,role }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const handleViewDetails = (item) => setSelectedItem(item);
  const closeDetails = () => setSelectedItem(null);

  return (
    <div className="flex flex-col gap-3">
      {data.map((item, index) => {
        const itemColorClass = getColorForTransaction(item.item);

        return (
          <div
            key={index}
            className="flex items-center justify-between p-4 bg-white drop-shadow-sm rounded-lg transition-all duration-200 hover:drop-shadow-md hover:scale-[1.01] transform cursor-pointer"
            onClick={
              !item.item.includes("Milk")
                ? () => handleViewDetails(item)
                : undefined
            }
          >
            {/* Left Side: Icon and Text */}
            <div className="flex items-center gap-4">
              <div className="flex items-center justify-center w-10 h-10 p-2 bg-gray-50 rounded-full transition-colors duration-200">
                {getIconForItem(item.item)}
              </div>
              <div className="flex flex-col">
                <p className="font-semibold text-base sm:text-lg text-gray-900">
                  {item.item}
                </p>
                <div className="text-xs sm:text-sm text-gray-500 mt-1 flex flex-wrap gap-x-3">
                  {item.date && <span>{item.date}</span>}
                  {item.quantityDisplay && <span>{item.quantityDisplay}</span>}
                  {item.name && <span>{item.name}</span>}
                </div>
              </div>
            </div>

            {/* Right Side: Amount */}
            <p
              className={`whitespace-nowrap font-bold text-lg sm:text-xl ${itemColorClass}`}
            >
              {item.money != null ? Math.abs(item.money).toFixed(1) : "0.0"} ₹
            </p>
          </div>
        );
      })}

      {/* Minimal Details Modal */}
      {selectedItem && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-20 flex justify-center items-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">
              Transaction Details
            </h3>
            <ul className="text-base text-gray-700 space-y-3">
              <li className="flex justify-between items-center">
                <span className="font-medium">Item:</span>
                <span>{selectedItem.item}</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="font-medium">Date:</span>
                <span>{selectedItem.date || "N/A"}</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="font-medium">Quantity:</span>
                <span>{selectedItem.quantityDisplay || "N/A"}</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="font-medium">Name:</span>
                <span>{selectedItem.name || "N/A"}</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="font-medium">Amount:</span>
                <span
                  className={`font-bold ${getColorForTransaction(
                    selectedItem.item
                  )}`}
                >
                  {" "}
                  {selectedItem.money.toFixed(1)}
                </span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              {role!="associated user" && (
              <button
                onClick={() => {
                  onDelete(selectedItem.id, "borrow");
                  closeDetails();
                }}
                className="flex-1 bg-red-600 text-white font-medium py-2 rounded-md hover:bg-red-700 transition-colors"
              >
                Delete
              </button>)}
              <button
                onClick={closeDetails}
                className="flex-1 text-gray-700 border border-gray-300 font-medium py-2 rounded-md hover:bg-gray-100 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionItem;
